import React from 'react';

import {
  StyledCircularProgress,
  ProgressCircleContainer,
  ProgressCircleWrapper,
  ProgressPercentageContainer,
} from './styledComponents';

import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

/**
 * ProgressCircle component
 * @param {number} percentage - The percentage of the progress
 * @param {boolean} useIsComplete - Whether to use the isComplete prop.
 * If useIsComplete is true, the progress circle will be green if the percentage is greater than or equal to 100.
 * If useIsComplete is false, the progress circle will be green only if the percentage is equal to 100.
 * @returns {React.ReactNode}
 */
export const ProgressCircle = ({
  percentage,
  useIsComplete = true,
  customSize = 32,
  font = ENUM_FONTS.TEXT_MICRO_HEIGHT_16,
}) => {
  const isComplete = percentage >= 100;
  const isEqual = percentage === 100;
  const displayPercentage = Math.round(percentage);

  return (
    <ProgressCircleContainer>
      <ProgressCircleWrapper>
        <StyledCircularProgress
          $isComplete={isComplete}
          $isEqual={isEqual}
          $useIsComplete={useIsComplete}
          size={customSize}
          thickness={4}
          value={displayPercentage > 100 ? 100 : displayPercentage}
          variant="determinate"
        />
        <ProgressPercentageContainer>
          <Text color={ENUM_COLORS.DARKEST} font={font}>
            {displayPercentage}%
          </Text>
        </ProgressPercentageContainer>
      </ProgressCircleWrapper>
    </ProgressCircleContainer>
  );
};
